import {useBusinessPolicies} from "../businessPolicies/useBusinessPolicies";
import React, {useEffect, useState} from "react";
import {ApiKeys} from "../apiKeys/apiKeys";
import {Switch} from "@nextui-org/switch";
import {FadeInSlide} from "../../motions/fadeInSlide";
import {InputEdit} from "../../components/inputEdit/InputEdit";
import {useLocations} from "../locations/useLocations";
import {AsButton, AsInput} from "../../subframe";
import {Listbox, ListboxItem, ListboxSection} from "@nextui-org/react";
import PhoneInput from "react-phone-input-2";
import {Edit2Icon, EditIcon, SaveIcon, CreditCard} from "lucide-react";
import {useSelector} from "react-redux";
import {selectUser, UserRoles} from "../../redux/userSlice";

const Payments = () => {
    const {
        account,
        onUpdateAccount,
        uploadWaiver,
        onDownloadWaiver,
        uploadConsent,
        onDownloadConsent,
        consentServices,
        onHandleConsentServiceChange,
    } = useBusinessPolicies();


    const {
        onSubmit,
        handleInputChange,
        isCreatingOrUpdatingNewShop,


    } = useLocations();

    const [isEditingTax, setIsEditingTax] = React.useState(false);
    const [isEditingCardFee, setIsEditingCardFee] = React.useState(false);
    const [taxValue, setTaxValue] = React.useState(
        account?.shops[0]?.taxPercentage ?? ''
    );
    const [cardFee, setCardFee] = React.useState<number>(
        account?.cardFeePercentage ?? ''
    );

    const [depositType, setDepositType] = React.useState<'percentage' | 'fixed'>(
        (account?.depositType as 'percentage' | 'fixed') ?? 'percentage'
    );
    const [depositValue, setDepositValue] = React.useState<number | string>(
        account?.depositValue ?? ''
    );
    // The fee is stored in cents and typed in dollars
    const [noShowFee, setNoShowFee] = React.useState<string>(
        account?.noShowFeeCents != null ? (account.noShowFeeCents / 100).toFixed(2) : ''
    );
    const saveNoShowFee = () => {
        const cents = Math.round((Number(noShowFee) || 0) * 100);
        setNoShowFee((cents / 100).toFixed(2));
        onUpdateAccount({noShowPolicy: 'FIXED_FEE', noShowFeeCents: cents});
    };


    const lateFeeFromAccount = account?.lateCancelFeeCents != null ? (account.lateCancelFeeCents / 100).toFixed(2) : '';
    const [lateCancelFee, setLateCancelFee] = React.useState<string>(lateFeeFromAccount);
    const saveLateCancelFee = () => {
        const cents = Math.round((Number(lateCancelFee) || 0) * 100);
        setLateCancelFee((cents / 100).toFixed(2));
        onUpdateAccount({lateCancelPolicy: 'FIXED_FEE', lateCancelFeeCents: cents});
    };
    const [cutoffHours, setCutoffHours] = React.useState<string>(String(account?.clientChangeCutoffHours ?? 24));
    const [rescheduleLimit, setRescheduleLimit] = React.useState<string>(String(account?.rescheduleLimit ?? 3));
    const saveWholeNumber = (key: 'clientChangeCutoffHours' | 'rescheduleLimit', value: string, max: number, reset: (v: string) => void) => {
        const n = Math.round(Number(value));
        if (!Number.isFinite(n) || n < 0 || n > max) {
            reset(String(account?.[key] ?? ''));
            return;
        }
        reset(String(n));
        if (n !== account?.[key]) onUpdateAccount({[key]: n});
    };

    // Fees, cutoffs and limits are the owner's call: only admins change them
    const currentUser = useSelector(selectUser);
    const canEditPolicies = currentUser?.role === UserRoles.ADMIN;

    const {paywallPermissions} = account;





    return (<div className="space-y-6">

        <ApiKeys/>


        <div>
            <h4 className="text-base font-medium text-gray-900 mb-4">Payment Requirements</h4>
            <div className="space-y-4">
                <div className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                    <div>
                        <h5 className="text-sm font-medium text-gray-900">Require Credit Card for Booking</h5>
                        <p className="text-sm text-gray-500 mt-1">Customers must provide a valid credit card to complete
                            bookings</p>
                    </div>

                    <Switch
                        className={'text-blue-700'}
                        size="sm"
                        defaultSelected={account.requireCreditCardForBooking}
                        onChange={(event) => onUpdateAccount({
                            requireCreditCardForBooking: event.target.checked,
                            enableCashPaymentForBooking: !event.target.checked ? false : account.enableCashPaymentForBooking,
                            paymentProcessingType: event.target.checked ? 'preauth' :null
                        })}
                    />

                </div>


                {account.requireCreditCardForBooking &&
                //     (<FadeInSlide direction="top" className={'w-full'}>
                //     <div className="flex p-4 gap-16 rounded-lg items-center justify-between border">
                //         <div className="flex flex-col gap-1">
                //             <p className="text-neutral-900">Enable cash payment</p>
                //             <p className="text-sm text-neutral-500">
                //                 Allow customers to keep their booking and choose to pay with
                //                 cash if their credit card can’t be validated.
                //             </p>
                //         </div>
                //         <Switch
                //             className={'text-blue-700'}
                //             size="sm"
                //             defaultSelected={account.enableCashPaymentForBooking}
                //             onChange={(event) => onUpdateAccount({
                //                 enableCashPaymentForBooking: event.target.checked,
                //             })}
                //         />
                //     </div>
                // </FadeInSlide>)
                        <div className="p-4 border border-gray-200 rounded-lg bg-blue-50">
                            <h5 className="text-sm font-medium text-gray-900 mb-3">Payment Processing Type</h5>
                            {/*<div className="space-y-3">*/}
                            {/*    <label className="flex items-center">*/}
                            {/*        <input*/}
                            {/*            type="radio"*/}
                            {/*            name="paymentType"*/}
                            {/*            value="preauth"*/}
                            {/*            defaultChecked*/}
                            {/*            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"*/}
                            {/*        />*/}
                            {/*        <div className="ml-3">*/}
                            {/*            <span className="text-sm font-medium text-gray-900">Pre-Authorization</span>*/}
                            {/*            <p className="text-xs text-gray-600">Hold funds on card, charge when service is completed</p>*/}
                            {/*        </div>*/}
                            {/*    </label>*/}
                            {/*    <label className="flex items-center">*/}
                            {/*        <input*/}
                            {/*            type="radio"*/}
                            {/*            name="paymentType"*/}
                            {/*            value="fullpayment"*/}
                            {/*            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"*/}
                            {/*        />*/}
                            {/*        <div className="ml-3">*/}
                            {/*            <span className="text-sm font-medium text-gray-900">Full Payment</span>*/}
                            {/*            <p className="text-xs text-gray-600">Charge the full amount immediately upon booking</p>*/}
                            {/*        </div>*/}
                            {/*    </label>*/}
                            {/*</div>*/}

                            <div className="space-y-3">
                                {/* Pre-Authorization */}
                                <label className="flex items-center">
                                    <input
                                        type="radio"
                                        name="paymentType"
                                        value="preauth"
                                        checked={account?.paymentProcessingType === 'preauth'}
                                        onChange={(event) =>
                                            onUpdateAccount({
                                                paymentProcessingType: event.target.value
                                            })
                                        }
                                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                    />
                                    <div className="ml-3">
                <span className="text-sm font-medium text-gray-900">
                    Pre-Authorization
                </span>
                                        <p className="text-xs text-gray-600">
                                            Hold funds on card, charge when service is completed
                                        </p>
                                    </div>
                                </label>

                                {/* Full Payment */}
                                <label className="flex items-center">
                                    <input
                                        type="radio"
                                        name="paymentType"
                                        value="full"
                                        checked={account?.paymentProcessingType === 'full'}
                                        onChange={(event) =>
                                            onUpdateAccount({
                                                paymentProcessingType: event.target.value
                                            })
                                        }
                                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                    />
                                    <div className="ml-3">
                <span className="text-sm font-medium text-gray-900">
                    Full Payment
                </span>
                                        <p className="text-xs text-gray-600">
                                            Charge the full amount immediately upon booking
                                        </p>
                                    </div>
                                </label>

                                {/* Deposit */}
                                <label className="flex items-center">
                                    <input
                                        type="radio"
                                        name="paymentType"
                                        value="deposit"
                                        checked={account?.paymentProcessingType === 'deposit'}
                                        onChange={(event) =>
                                            onUpdateAccount({
                                                paymentProcessingType: event.target.value
                                            })
                                        }
                                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                                    />
                                    <div className="ml-3">
                <span className="text-sm font-medium text-gray-900">
                    Deposit
                </span>
                                        <p className="text-xs text-gray-600">
                                            Charge a deposit at booking and save the card on file for the
                                            remaining balance at checkout
                                        </p>
                                    </div>
                                </label>

                                {account?.paymentProcessingType === 'deposit' && (
                                    <div className="pt-3 mt-1 border-t border-gray-200 space-y-3">
                                        <label className="block text-sm font-medium text-gray-900">
                                            Deposit Amount
                                        </label>
                                        <div className="flex gap-2">
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setDepositType('percentage');
                                                    onUpdateAccount({depositType: 'percentage', depositValue: Number(depositValue) || 0});
                                                }}
                                                className={`px-3 py-1.5 text-sm rounded-md border ${
                                                    depositType === 'percentage'
                                                        ? 'bg-blue-600 text-white border-blue-600'
                                                        : 'bg-white text-gray-700 border-gray-300'
                                                }`}
                                            >
                                                Percentage
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    setDepositType('fixed');
                                                    onUpdateAccount({depositType: 'fixed', depositValue: Number(depositValue) || 0});
                                                }}
                                                className={`px-3 py-1.5 text-sm rounded-md border ${
                                                    depositType === 'fixed'
                                                        ? 'bg-blue-600 text-white border-blue-600'
                                                        : 'bg-white text-gray-700 border-gray-300'
                                                }`}
                                            >
                                                Fixed Amount
                                            </button>

                                            <div className="relative w-28">
                                                <input
                                                    type="number"
                                                    value={depositValue}
                                                    min="0"
                                                    max={depositType === 'percentage' ? 100 : undefined}
                                                    step="0.01"
                                                    onChange={(e) => setDepositValue(e.target.value)}
                                                    onBlur={() => onUpdateAccount({
                                                        depositType,
                                                        depositValue: Number(depositValue) || 0
                                                    })}
                                                    className="w-full pl-3 pr-7 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                                />
                                                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-gray-500">
                                                    {depositType === 'percentage' ? '%' : '$'}
                                                </span>
                                            </div>
                                        </div>

                                        <p className="text-xs text-gray-500">
                                            {depositType === 'percentage'
                                                ? `Charges ${depositValue || 0}% of the service total at booking. The remaining balance is billed to the saved card at checkout.`
                                                : `Charges $${depositValue || 0} at booking. The remaining balance is billed to the saved card at checkout.`}
                                        </p>

                                        <div className="flex items-start gap-2 p-2.5 rounded-md bg-blue-50 text-xs text-blue-800">
                                            <CreditCard size={16} className="shrink-0 mt-0.5"/>
                                            <span>
                                                The customer's card will be securely saved on file for staff
                                                to bill the remaining balance at checkout.
                                            </span>
                                        </div>
                                    </div>
                                )}
                            </div>


                        </div>




                }


            </div>
        </div>

        {!canEditPolicies && (
            <p className="text-sm text-gray-500">Only an admin can change the no-show, cancellation and reschedule settings.</p>
        )}

        <fieldset disabled={!canEditPolicies} className="space-y-6 disabled:opacity-60">
        <div>
            <h4 className="text-base font-medium text-gray-900 mb-4">No-Show Policy</h4>
            <div className="p-4 border border-gray-200 rounded-lg space-y-3">
                <p className="text-sm text-gray-500">
                    What to charge the card on file when staff mark a client as a no-show. Any deposit already
                    paid is taken off the charge. Admins can waive the fee for a client.
                </p>

                <label className="flex items-center">
                    <input
                        type="radio"
                        name="noShowPolicy"
                        value="NONE"
                        checked={(account?.noShowPolicy ?? 'NONE') === 'NONE'}
                        onChange={() => onUpdateAccount({noShowPolicy: 'NONE'})}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                    />
                    <div className="ml-3">
                        <span className="text-sm font-medium text-gray-900">No charge</span>
                        <p className="text-xs text-gray-600">Nothing is charged. The shop keeps any deposit.</p>
                    </div>
                </label>

                <label className="flex items-center">
                    <input
                        type="radio"
                        name="noShowPolicy"
                        value="FULL_AMOUNT"
                        checked={account?.noShowPolicy === 'FULL_AMOUNT'}
                        onChange={() => onUpdateAccount({noShowPolicy: 'FULL_AMOUNT'})}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                    />
                    <div className="ml-3">
                        <span className="text-sm font-medium text-gray-900">Full service amount</span>
                        <p className="text-xs text-gray-600">Charge the full price of the booking, less any deposit.</p>
                    </div>
                </label>

                <label className="flex items-center">
                    <input
                        type="radio"
                        name="noShowPolicy"
                        value="FIXED_FEE"
                        checked={account?.noShowPolicy === 'FIXED_FEE'}
                        onChange={saveNoShowFee}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                    />
                    <div className="ml-3">
                        <span className="text-sm font-medium text-gray-900">Fixed fee</span>
                        <p className="text-xs text-gray-600">Charge a set fee, less any deposit.</p>
                    </div>
                </label>

                {account?.noShowPolicy === 'FIXED_FEE' && (
                    <div className="pt-3 mt-1 border-t border-gray-200">
                        <label htmlFor="noShowFee" className="block text-sm font-medium text-gray-900 mb-2">
                            No-Show Fee
                        </label>
                        <div className="relative w-28">
                            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-gray-500">$</span>
                            <input
                                id="noShowFee"
                                type="number"
                                value={noShowFee}
                                min="0"
                                step="0.01"
                                onChange={(e) => setNoShowFee(e.target.value)}
                                onBlur={saveNoShowFee}
                                className="w-full pl-7 pr-3 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>

        <div>
            <h4 className="text-base font-medium text-gray-900 mb-4">Online Cancel &amp; Reschedule</h4>
            <div className="p-4 border border-gray-200 rounded-lg space-y-4">
                <p className="text-sm text-gray-500">
                    Clients can cancel or reschedule their next appointment from the link in their confirmation
                    email. Cancelling online refunds any deposit. Rescheduling keeps the deposit or saved card.
                </p>
                <div className="flex flex-wrap gap-6">
                    <div>
                        <label htmlFor="cutoffHours" className="block text-sm font-medium text-gray-900 mb-2">
                            Cutoff (hours before the appointment)
                        </label>
                        <input
                            id="cutoffHours"
                            type="number"
                            min="0"
                            max="720"
                            step="1"
                            value={cutoffHours}
                            onChange={(e) => setCutoffHours(e.target.value)}
                            onBlur={() => saveWholeNumber('clientChangeCutoffHours', cutoffHours, 720, setCutoffHours)}
                            className="w-28 px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                        <p className="text-xs text-gray-500 mt-1">Inside this window clients have to call the shop.</p>
                    </div>
                    <div>
                        <label htmlFor="rescheduleLimit" className="block text-sm font-medium text-gray-900 mb-2">
                            Reschedules allowed per booking
                        </label>
                        <input
                            id="rescheduleLimit"
                            type="number"
                            min="0"
                            max="20"
                            step="1"
                            value={rescheduleLimit}
                            onChange={(e) => setRescheduleLimit(e.target.value)}
                            onBlur={() => saveWholeNumber('rescheduleLimit', rescheduleLimit, 20, setRescheduleLimit)}
                            className="w-28 px-3 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        />
                        <p className="text-xs text-gray-500 mt-1">0 turns online rescheduling off.</p>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <h4 className="text-base font-medium text-gray-900 mb-4">Late-Cancel Fee</h4>
            <div className="p-4 border border-gray-200 rounded-lg space-y-3">
                <p className="text-sm text-gray-500">
                    What to charge when a client calls to cancel inside the cutoff and staff cancel for them. Any
                    deposit already paid is taken off the charge. Admins can waive it.
                </p>
                {([
                    ['NONE', 'No charge', 'Nothing is charged. The shop keeps any deposit.'],
                    ['FULL_AMOUNT', 'Full service amount', 'Charge the full price of the booking, less any deposit.'],
                    ['FIXED_FEE', 'Fixed fee', 'Charge a set fee, less any deposit.'],
                ] as const).map(([value, label, hint]) => (
                    <label key={value} className="flex items-center">
                        <input
                            type="radio"
                            name="lateCancelPolicy"
                            value={value}
                            checked={(account?.lateCancelPolicy ?? 'NONE') === value}
                            onChange={() => value === 'FIXED_FEE' ? saveLateCancelFee() : onUpdateAccount({lateCancelPolicy: value})}
                            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                        />
                        <div className="ml-3">
                            <span className="text-sm font-medium text-gray-900">{label}</span>
                            <p className="text-xs text-gray-600">{hint}</p>
                        </div>
                    </label>
                ))}
                {account?.lateCancelPolicy === 'FIXED_FEE' && (
                    <div className="pt-3 mt-1 border-t border-gray-200">
                        <label htmlFor="lateCancelFee" className="block text-sm font-medium text-gray-900 mb-2">
                            Late-Cancel Fee
                        </label>
                        <div className="relative w-28">
                            <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-gray-500">$</span>
                            <input
                                id="lateCancelFee"
                                type="number"
                                value={lateCancelFee}
                                min="0"
                                step="0.01"
                                onChange={(e) => setLateCancelFee(e.target.value)}
                                onBlur={saveLateCancelFee}
                                className="w-full pl-7 pr-3 py-1.5 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>
                    </div>
                )}
            </div>
        </div>
        </fieldset>

        <div>
            <h4 className="text-base font-medium text-gray-900 mb-4">Pricing Settings</h4>
            {/*{!paywallPermissions?.dualPricing && (<UpgradeBanner text={"Your plan doesn't include this feature."}/>)}*/}
            <div className="space-y-4 mt-2">
                <div className="p-4 border border-gray-200 rounded-lg">
                    <div className="flex items-center justify-between mb-4">
                        <div>
                            <h5 className="text-sm font-medium text-gray-900">Enable Dual Pricing</h5>
                            <p className="text-sm text-gray-500 mt-1">Show different prices for cash and credit card
                                payments</p>
                        </div>
                        <Switch
                            className={'text-blue-700'}
                            size="sm"
                            defaultSelected={account.dualPricingEnabled}
                            onChange={(event) => onUpdateAccount({
                                dualPricingEnabled: event.target.checked,
                            })}
                            // isDisabled={!paywallPermissions?.dualPricing}
                        />
                    </div>
                    {account.dualPricingEnabled && (<div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Credit Card Fee (%)
                        </label>
                        <div className="relative  max-w-xs">
                            <input
                                type="number"
                                value={cardFee}
                                min="0"
                                max="15"
                                step="0.01"
                                disabled={!isEditingCardFee}
                                onChange={(e) => setCardFee(+e.target.value)}
                                className={`w-full px-3 py-2 border rounded-lg pr-10
            ${isEditingCardFee
                                    ? 'border-blue-500 focus:ring-2 focus:ring-blue-500'
                                    : 'bg-gray-100 cursor-not-allowed border-gray-300'}
        `}
                            />

                            {/* Edit Icon */}
                            {!isEditingCardFee && (
                                <button
                                    type="button"
                                    onClick={() => setIsEditingCardFee(true)}
                                    className="absolute right-2 top-2.5 text-gray-500 hover:text-blue-600"
                                >
                                    <Edit2Icon size={24}/>
                                </button>
                            )}

                            {isEditingCardFee && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        onUpdateAccount({
                                            cardFeePercentage: Number(cardFee)
                                        });
                                        setIsEditingCardFee(false);
                                    }}
                                    className="absolute right-2 top-2.5 text-green-600 hover:text-green-700"
                                >
                                    <SaveIcon size={24}/>
                                </button>
                            )}
                        </div>
                        <p className="text-xs text-gray-500 mt-1">Additional fee for credit card payments</p>
                    </div>)}
                </div>
            </div>
        </div>

        {account?.shops?.length >0 && <div>
            <h4 className="text-base font-medium text-gray-900 mb-4">Tax Rate</h4>
            <div className="space-y-4">
                <div className="p-4 border border-gray-200 rounded-lg">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Tax Rate (%)
                        </label>
                        <div className="relative  max-w-xs">
                            <input
                                type="number"
                                value={taxValue}
                                min="0"
                                max="15"
                                step="0.01"
                                disabled={!isEditingTax}
                                onChange={(e) => setTaxValue(e.target.value)}
                                className={`w-full px-3 py-2 border rounded-lg pr-10
            ${isEditingTax
                                    ? 'border-blue-500 focus:ring-2 focus:ring-blue-500'
                                    : 'bg-gray-100 cursor-not-allowed border-gray-300'}
        `}
                            />

                            {/* Edit Icon */}
                            {!isEditingTax && (
                                <button
                                    type="button"
                                    onClick={() => setIsEditingTax(true)}
                                    className="absolute right-2 top-2.5 text-gray-500 hover:text-blue-600"
                                >
                                    <Edit2Icon size={24}/>
                                </button>
                            )}

                            {isEditingTax && (
                                <button
                                    type="button"
                                    onClick={() => {
                                        onUpdateAccount({
                                            taxPercentage: Number(taxValue)
                                        });
                                        setIsEditingTax(false);
                                    }}
                                    className="absolute right-2 top-2.5 text-green-600 hover:text-green-700"
                                >
                                    <SaveIcon size={24}/>
                                </button>
                            )}
                        </div>

                        <p className="text-xs text-gray-500 mt-1">Sales tax rate applied to services and products</p>
                    </div>

                    <div className="mt-4 pt-4 border-t border-gray-200">
                        <div className="space-y-3">
                            <div className="flex items-center justify-between">
                                <div>
                                    <h5 className="text-sm font-medium text-gray-900">Apply Tax to Services</h5>
                                    <p className="text-sm text-gray-500">Include tax on all service bookings</p>
                                </div>
                                <label className="relative inline-flex items-center cursor-pointer">
                                    <Switch
                                        className={'text-blue-700'}
                                        size="sm"
                                        defaultSelected={account.applyTaxToService}
                                        onChange={(event) => onUpdateAccount({
                                            applyTaxToService: event.target.checked,
                                        })}
                                    />
                                </label>
                            </div>

                            <div className="flex items-center justify-between">
                                <div>
                                    <h5 className="text-sm font-medium text-gray-900">Apply Tax to Products</h5>
                                    <p className="text-sm text-gray-500">Include tax on all product sales</p>
                                </div>
                                <label className="relative inline-flex items-center cursor-pointer">

                                    <Switch
                                        className={'text-blue-700'}
                                        size="sm"
                                        defaultSelected={account.applyTaxToProduct}
                                        onChange={(event) => onUpdateAccount({
                                            applyTaxToProduct: event.target.checked,
                                        })}
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>}

    </div>)


}


export default Payments

